<template>
    <div>
        <login-template :loading="state.loading">
            <template #form-title> Set Password </template>
            <template #form-paragraph>Please set your password to log onto your account.</template>
            <template #form-section>
                <!-- User login email and password form -->
                <div class="p-fluid">
                    <div class="field">
                        <base-text-input v-model="state.password" type="password" placeholder="Enter New Password" @keyup.enter="resetPassword" :errorMessage="formErrors.password" />
                    </div>
                    <div class="field">
                        <base-text-input v-model="state.confirmPassword" type="password" placeholder="Confirm Password" @keyup.enter="resetPassword" :errorMessage="formErrors.confirmPassword" />
                    </div>
                </div>
                <div class="p-fluid">
                    <Button label="Reset Password" type="button" @click.prevent="resetPassword" />
                </div>
                <div class="requirements">
                    <br />
                    <strong> Password must meet the following requirements: </strong>
                    <ul>
                        <li>One uppercase</li>
                        <li>One lowercase</li>
                        <li>Symbols</li>
                        <li>Numbers</li>
                    </ul>
                </div>
            </template>
        </login-template>
    </div>
</template>

<script setup>
import BaseTextInput from '../../custom-inputs/BaseTextInput.vue';
import LoginTemplate from '../components/LoginTemplate.vue';

import { reactive } from 'vue';
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';
import { authStore, formErrorStore } from '../../../store/global-stores';
import { PasswordResetSchema, handleErrors } from '../../../utilities/schemas';
import { showToast } from '../../../utilities/toast-handler';

const route = useRoute();
const { formErrors } = storeToRefs(formErrorStore);

const state = reactive({
    password: null,
    confirmPassword: null,
    loader: false,
    submitted: false,
});

const resetPassword = async () => {
    // password match validation issue so we are testing it manually
    if (state.password !== state.confirmPassword) {
        showToast({ severity: 'info' }, 'Both Passwords need to match');
    }
    await handleValidation(PasswordResetSchema);
    const body = {
        token: route.query.token,
        password_1: state.password,
        password_2: state.confirmPassword,
        mail_otp: route.query.mail_otp,
    };
    // if validation success then submit
    await authStore.resetPassword(body);
};

const handleValidation = async (schema) => {
    try {
        // initiate the loader and submit
        state.loader = true;
        state.submitted = true;
        // validate the schema first
        await schema.validate({ password: state.password, confirmPassword: state.confirmPassword }, { abortEarly: false });
        formErrorStore.clearErrors();
    } catch (error) {
        if (error.inner && typeof error.inner === 'object') {
            const errors = handleErrors(error);
            formErrorStore.addErrors(errors);
            showToast({}, 'Input data invalid');
        }
    } finally {
        state.loader = false;
    }
};
</script>

<style scoped>
.requirements {
    text-align: left;
}
</style>
